// extracted by mini-css-extract-plugin
module.exports = {"transferEmail":"FiberDeceasedForm_transferEmail__AuJfp"};